export default {
  checkout: () => import("/src/nuxt-app/layouts/checkout.vue").then(m => m.default || m),
  default: () => import("/src/nuxt-app/layouts/default.vue").then(m => m.default || m),
  thankyou: () => import("/src/nuxt-app/layouts/thankyou.vue").then(m => m.default || m)
}